module.exports = __webpack_public_path__ + "img/bg.874ff4d4.png";